export const NAMESPACE = 'tracking';
